import TreeViewCustom from '@Components/TreeViewCustom';
import React from "react";

export default class ProducerSelectorEos extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			checkedItems: [],
			productoresData: [],
		};
		this.currentIndex = null;
		this.productoresChildsSelected = [];
		this.treeViewRefs = [];
	}

	componentWillUnmount() {
		this.treeViewRefs = [];
		this.productoresData = [];
		this.productoresChildsSelected = [];
	}

	processItem = item => {
		let itemIndex = -1;
		const checkedItems = this.state.checkedItems;

		checkedItems.forEach((currentItem, index) => {
			if (currentItem.id === item.id) {
				itemIndex = index;
				return false;
			}
		});

		if (item.selected) {
			checkedItems.push(item);
		} else if (!item.selected) {
			checkedItems.splice(itemIndex, 1);
		}

		return checkedItems;
	};

	setProductoresSelectedAll = e => {
		let checkAll = e.value;
		if (checkAll !== undefined && e.component && e.component.getNodes) {
			try {
				e.component.getNodes()
				.forEach((node) => this.setProductoresSelected({node: node}));
			} catch (error) {
				console.warn('Error in setProductoresSelectedAll:', error);
			}
		}
	}

	updateProductoresData = (updatedItem) => {
		const productoresData = [...this.state.productoresData];
		
		productoresData.forEach(menu => {
			if (menu.items) {
				// Buscar y actualizar el item en el nivel principal
				const itemIndex = menu.items.findIndex(item => item.id === updatedItem.id);
				if (itemIndex !== -1) {
					menu.items[itemIndex] = { ...menu.items[itemIndex], selected: updatedItem.selected };
				}
				
				// Buscar y actualizar en los hijos
				menu.items.forEach(parentItem => {
					if (parentItem.items) {
						const childIndex = parentItem.items.findIndex(child => child.id === updatedItem.id);
						if (childIndex !== -1) {
							parentItem.items[childIndex] = { ...parentItem.items[childIndex], selected: updatedItem.selected };
						}
					}
				});
			}
		});
		
		return productoresData;
	};

	setProductoresSelected = item => {
		if (!item) {
			return;
		}

		let checkedItemsNew = [];

		// Procesar el item seleccionado
		checkedItemsNew = this.processItem({
			id: item.id,
			text: item.text,
			core: item.core,
			itemData: item.itemData || {},
			selected: item.selected,
			category: item.category || ""
		});

		// Procesar hijos si existen
		if (item.items && item.items.length) {
			item.items.forEach(child => {
				checkedItemsNew = this.processItem({
					id: child.id,
					text: child.text,
					core: child.core,
					itemData: child.itemData || {},
					selected: child.selected,
					category: item.text
				});
			});
		}

		checkedItemsNew = checkedItemsNew.filter((v, i, a) => a.findIndex(t => (t.id === v.id && t.name === v.name)) === i);
		
		// Actualizar el estado de los datos de productores
		const updatedProductoresData = this.updateProductoresData(item);
		
		if (this._isMounted) {
			this.setState({ 
				checkedItems: checkedItemsNew,
				productoresData: updatedProductoresData
			}, () => { 
				if (this.props.onCheckedItemsChanged) {
					this.props.onCheckedItemsChanged(this.state.checkedItems);
				}
			});
		}
	};

	componentDidMount() {
		this._isMounted = true;
		// Inicializar el estado con los datos de los productores
		if (this.props.producers) {
			this.setState({ productoresData: this.props.producers });
		}
	}

	componentDidUpdate(prevProps) {
		// Actualizar el estado si cambian los props de productores
		if (prevProps.producers !== this.props.producers) {
			this.setState(prevState => {
				// Función para resetear el estado selected de todos los items
				const resetSelectedState = (data) => {
					if (!data || !Array.isArray(data)) return data;
					return data.map(menu => ({
						...menu,
						items: menu.items ? menu.items.map(item => ({
							...item,
							selected: false,
							items: item.items ? item.items.map(child => ({
								...child,
								selected: false
							})) : []
						})) : []
					}));
				};

				// Si los nuevos productores están vacíos, resetear completamente el estado
				if (!this.props.producers || this.props.producers.length === 0) {
					return {
						productoresData: resetSelectedState(this.props.producers),
						checkedItems: []
					};
				}
				
				// Si no hay datos previos, usar los nuevos datos directamente
				if (!prevState.productoresData || prevState.productoresData.length === 0) {
					return {
						productoresData: resetSelectedState(this.props.producers),
						checkedItems: []
					};
				}
				
				// Si hay datos previos, fusionarlos pero resetear las selecciones si los productores cambiaron significativamente
				const producersChanged = JSON.stringify(prevProps.producers) !== JSON.stringify(this.props.producers);
				
				if (producersChanged) {
					// Resetear selecciones cuando los productores cambian (como en clear filters)
					return {
						productoresData: resetSelectedState(this.props.producers),
						checkedItems: []
					};
				}
				
				// Fusionar preservando las selecciones solo si los productores no cambiaron
				const mergedData = this.mergeProducerData(this.props.producers, prevState.productoresData);
				return { productoresData: mergedData };
			});
		}
	}

	mergeProducerData = (newData, oldData) => {
		if (!newData || !Array.isArray(newData)) return oldData;
		if (!oldData || !Array.isArray(oldData)) return newData;

		// Crear un mapa de los items seleccionados previamente
		const selectedItemsMap = new Map();
		
		// Recorrer los datos antiguos para extraer los items seleccionados
		oldData.forEach(menu => {
			if (menu.items) {
				menu.items.forEach(item => {
					if (item.selected) {
						selectedItemsMap.set(item.id, item.selected);
					}
					// También revisar los hijos
					if (item.items) {
						item.items.forEach(child => {
							if (child.selected) {
								selectedItemsMap.set(child.id, child.selected);
							}
						});
					}
				});
			}
		});

		// Aplicar las selecciones previas a los nuevos datos
		return newData.map(menu => {
			if (menu.items) {
				const updatedItems = menu.items.map(item => {
					const updatedItem = {
						...item,
						selected: selectedItemsMap.has(item.id) ? selectedItemsMap.get(item.id) : (item.selected || false)
					};
					
					// También actualizar los hijos
					if (updatedItem.items) {
						updatedItem.items = updatedItem.items.map(child => ({
							...child,
							selected: selectedItemsMap.has(child.id) ? selectedItemsMap.get(child.id) : (child.selected || false)
						}));
					}
					
					return updatedItem;
				});
				
				return { ...menu, items: updatedItems };
			}
			return menu;
		});
	}

	// Método para resetear las selecciones (para ser llamado externamente)
	resetSelections = () => {
		// Función para resetear el estado selected de todos los items
		const resetSelectedState = (data) => {
			if (!data || !Array.isArray(data)) return data;
			return data.map(menu => ({
				...menu,
				items: menu.items ? menu.items.map(item => ({
					...item,
					selected: false,
					items: item.items ? item.items.map(child => ({
						...child,
						selected: false
					})) : []
				})) : []
			}));
		};

		this.setState({
			checkedItems: [],
			productoresData: resetSelectedState(this.state.productoresData)
		});
	}

	// Método para seleccionar/deseleccionar todos los productores
	toggleSelectAll = () => {
		const { productoresData } = this.state;
		const allSelected = this.areAllSelected();

		// Función para actualizar el estado de selección
		const updateSelection = (data, selected) => {
			return data.map(menu => ({
				...menu,
				items: menu.items ? menu.items.map(item => {
					const updatedItem = {
						...item,
						selected: selected
					};

					// También actualizar los hijos
					if (updatedItem.items) {
						updatedItem.items = updatedItem.items.map(child => ({
							...child,
							selected: selected
						}));
					}

					return updatedItem;
				}) : []
			}));
		};

		const newSelected = !allSelected;
		const updatedProductoresData = updateSelection(productoresData, newSelected);

		// Recopilar todos los items seleccionados/deseleccionados
		const allCheckedItems = [];
		updatedProductoresData.forEach(menu => {
			if (menu.items) {
				menu.items.forEach(item => {
					if (newSelected) {
						allCheckedItems.push({
							id: item.id,
							text: item.text,
							core: item.core,
							itemData: item.itemData || {},
							selected: newSelected,
							category: ""
						});
					}

					if (item.items) {
						item.items.forEach(child => {
							if (newSelected) {
								allCheckedItems.push({
									id: child.id,
									text: child.text,
									core: child.core,
									itemData: child.itemData || {},
									selected: newSelected,
									category: item.text
								});
							}
						});
					}
				});
			}
		});

		this.setState({
			productoresData: updatedProductoresData,
			checkedItems: newSelected ? allCheckedItems : []
		}, () => {
			if (this.props.onCheckedItemsChanged) {
				this.props.onCheckedItemsChanged(this.state.checkedItems);
			}
		});
	}

	// Método para verificar si todos los items están seleccionados
	areAllSelected = () => {
		const { productoresData } = this.state;
		if (!productoresData || productoresData.length === 0) return false;

		for (const menu of productoresData) {
			if (!menu.items) continue;

			for (const item of menu.items) {
				if (!item.selected) return false;
				if (item.items) {
					for (const child of item.items) {
						if (!child.selected) return false;
					}
				}
			}
		}

		return true;
	}

	// Método para verificar si hay algún item seleccionado
	areSomeSelected = () => {
		const { checkedItems } = this.state;
		return checkedItems && checkedItems.length > 0;
	}

	render() {
		if (!this.state.productoresData) {
			return null;
		}

		const allSelected = this.areAllSelected();
		const someSelected = this.areSomeSelected();

		return (
			<>
				<div className="row mr-0 ml-0">
					<div className="col-12 pt-2 pb-2 d-flex justify-content-between align-items-center border-bottom">
						<span className="fw-bold text-primary mb-0">Productores</span>
						<button
							type="button"
							className="btn btn-sm rounded-pill px-3 shadow-sm"
							onClick={this.toggleSelectAll}
						>
							{allSelected ? (
								<span>
									<i className="bi bi-dash-square-fill me-1"></i>
									Limpiar selección
								</span>
							) : (
								<span className="text-primary">
									<i className="bi bi-check-square-fill me-1"></i>
									Seleccionar todos
								</span>
							)}
						</button>
					</div>
				</div>
				<div className="row mr-0 ml-0">
					{(
						<div className="col-6 pt-2 mt-2">
							{
								this.state.productoresData.map((menu) => {
									if (!menu || !menu.items) {
										return null;
									}

									return (
										<div key={menu.items[0]?.id ?? crypto.randomUUID()} className={`${(menu.items.length ? "" : "mr-0 ml-0")} row productores-tree`}>
											<TreeViewCustom
												items={menu.items}
												onItemToggle={this.setProductoresSelected}
											/>
										</div>
									);
								})
							}
						</div>
					)}
				</div>
			</>
		);
	}
}

ProducerSelectorEos.defaultProps = {
	producers: [],
	hideChilds: false,
	selectionMultiple: true
};
